export default __webpack_public_path__ + "static/media/podcard_example.d3be3214.mp3";